import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { store } from '@/store';
import App from '@/App';
import { theme } from '@/theme';
import TypesafeI18n from '@/i18n/i18n-react';
import { detectLocale } from '@/i18n/i18n-util';
import { loadAllLocales } from '@/i18n/i18n-util.sync';
import { AppDialogProvider } from '@/components/dialogs/AppDialog';

// Load all translation files
loadAllLocales();

// Detect user's preferred locale from browser settings
const locale = detectLocale();

// Read persisted theme — default to dark if nothing stored yet
const storedTheme = localStorage.getItem('theme');
const initialMode: 'dark' | 'light' = storedTheme === 'light' ? 'light' : 'dark';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <BrowserRouter>
            <TypesafeI18n locale={locale}>
                <Provider store={store}>
                    <ThemeProvider theme={theme} defaultMode={initialMode} modeStorageKey="theme">
                        <CssBaseline />
                        <AppDialogProvider>
                            <App />
                        </AppDialogProvider>
                    </ThemeProvider>
                </Provider>
            </TypesafeI18n>
        </BrowserRouter>
    </StrictMode>
);
